import { NavigationTitle } from '@global-dax-ad-platform/dax-modules';
import {
  MenuCollapseIcon,
  MenuExpandIcon,
} from '@global-engineering-shared/gweb-material-icons-global-next';
import { handleNavigate, NavigationProvider } from '@global-engineering-shared/gweb-material-lab';
import { useLocation, useNavigate } from 'react-router';

import AppLayout from 'components/App/components/AppLayout';
import { getDefaultNavigationItems } from 'utils/sideNavBar';

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <NavigationProvider
      defaultNavigationItems={getDefaultNavigationItems(0)}
      handleNavigate={(_e, item) => {
        handleNavigate(item, navigate);
      }}
      location={location}
      NavigationTitle={<NavigationTitle />}
      headerIcons={{
        expandIcon: <MenuExpandIcon />,
        collapseIcon: <MenuCollapseIcon />,
      }}
    >
      <AppLayout />
    </NavigationProvider>
  );
};

export default App;
